import { c as _c } from "react-compiler-runtime";
import { View } from 'foundations-components/components/View';
import { styled } from '../utils/styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const COMMENT_BUTTON_WIDTH = 116.7;
const CANCEL_BUTTON_WIDTH = 96.63;
const ButtonSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonSkeleton"
})(["background-color:", ";height:40px;width:", "px;margin-right:12px;"], ({
  theme
}) => theme.color['fill-field-default'], ({
  width
}) => width);
const ButtonsSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonsSkeleton"
})(["margin-top:12px;display:flex;"]);
export default function MiniCommenterSkeleton(t0) {
  "use memo";

  const $ = _c(4);
  const {
    hasModuleParentComment
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(View, {
      blockSize: "137px",
      borderRadius: "400",
      backgroundColor: "fill-field-default"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t1, /*#__PURE__*/_jsxs(ButtonsSkeleton, {
        children: [/*#__PURE__*/_jsx(ButtonSkeleton, {
          width: COMMENT_BUTTON_WIDTH
        }), /*#__PURE__*/_jsx(ButtonSkeleton, {
          width: CANCEL_BUTTON_WIDTH
        })]
      })]
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const editorAndButtons = t2;
  let t3;
  if ($[2] !== hasModuleParentComment) {
    t3 = /*#__PURE__*/_jsx(View, {
      padding: "400",
      children: hasModuleParentComment ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          blockSize: "100px",
          borderRadius: "300",
          backgroundColor: "fill-field-default",
          marginBlockEnd: "300"
        }), /*#__PURE__*/_jsx(View, {
          marginInlineStart: "400",
          children: editorAndButtons
        })]
      }) : editorAndButtons
    });
    $[2] = hasModuleParentComment;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}